module.exports = function () {
  // Only show popup, if user have noget accepted cookie
  if (!$.cookie('cookie-accept')) {

    // Give people a chance to land on the page, and the page to load
    setTimeout(function() {
      // Open cookie accept notification
      $('#notification-cookies').notification('open', {
        callbacks: {
          close: function() {
            // Open close, register cookie
            $.cookie('cookie-accept', true);

            // Show social media icons
            setTimeout(function(){
              $('.a2a_kit').removeClass('hide');
            }, 2000);
          }
        }
      });
    }, 2000);
  } else {
    // Show social media icons
    $('.a2a_kit').removeClass('hide');
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./source/js/accept-cookies.js
 ** module id = 7
 ** module chunks = 0
 **/